<div class="FcAgEditor__MenuItem FcAgEditor__MenuItem--Icon">
    <div class="FcAgEditor__MenuItem--IconContainer" [innerHTML]="html | sanitizeHtml" (mousedown)="toggleDropdown($event)"
         title="Table">
    </div>
</div>

<div class="FcAgEditor__Dropdown tableMenu" *ngIf="isDropdownOpen">
    <div class="FcAgEditor__Dropdown--DropdownMenu">
        <div class="FcAgEditor__Dropdown--Item" *ngFor="let item of items; trackBy: trackByIndex"
             [ngClass]="{'disabled': item.isDisabled()}"
             (mousedown)="onClick($event, item)">
            {{ item.label }}
        </div>
    </div>
</div>
